import {
  baseMediaStylesRfnd,
  basePageStyles,
  baseTitleStyles,
  desktopMediaQuery,
} from 'nove8/components/styles'
import { Color } from 'root-constants'
import styled from 'styled-components'
import { OptionVariant2 } from '../../components/OptionVariant2'

export const StyledBreedFrequency = {
  Wrapper: styled.div`
    ${basePageStyles};
    padding-top: 78px;
    overflow-y: auto;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    ${baseMediaStylesRfnd};
    margin-bottom: 120px;
  `,
  OptionsContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    justify-content: flex-start;
    height: 100%;
    gap: 10px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media ${desktopMediaQuery} {
      margin-bottom: 24px;
      justify-content: start;
    }
  `,
  Title: styled.h2`
    ${baseTitleStyles};
    font-family: 'Inter', sans-serif;
    font-size: 28px;
    line-height: 130%;
    font-weight: 900;
    color: ${Color.BLACK_SECONDARY};
    margin-bottom: 2px;
  `,
  OptionVariant2: styled(OptionVariant2)`
    position: relative;
  `,
  OptionIconContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    width: 56px;
    height: 55px;
  `,
  OptionIcon: styled.img`
    width: 100%;
    margin-left: -16px;
  `,
  OptionContentContainer: styled.div`
    flex: 1;
    display: flex;
    align-items: center;
  `,
  OptionTitle: styled.p`
    line-height: 20px;
    font-family: 'Inter', sans-serif;
    color: ${Color.BLACK_SECONDARY};
    font-weight: 700;
  `,
  OptionEmoji: styled.div`
    font-size: 24px;
    margin-right: 12px;
  `,
  OptionEmoji1: styled.div`
    font-size: 28px;
    margin-right: 16px;
  `,
  OptionSubtitle: styled.p`
    font-weight: 400;
    line-height: 20px;
  `,
  StickyButtonContainer: styled.div`
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    background: ${Color.WHITE};
    bottom: 0;
    padding: 8px 0 16px;
  `,
  ButtonContainer: styled.div`
    ${baseMediaStylesRfnd};
    z-index: 1;
  `,
  TextButton: styled.button`
    display: block;
    cursor: pointer;
    border: none;
    outline: none;
    text-decoration: none;
    text-align: center;
    font-size: 15px;
    margin-top: 11px;
    font-weight: 700;
    line-height: 27px;
    text-decoration-line: underline;
    color: ${Color.BLACK_SECONDARY};
    background-color: transparent;
  `,
}
